import './styles.scss'

export interface IStep {
  title: string
  size?: 'large' | 'medium' | 'small'
}

export const Step = ({ title, size = 'medium' }: IStep) => {
  return (
    <div className="container__step" data-size={size}>
      {title}
    </div>
  )
}